/* ModalCreditsTransactions.js */
/* @author: anghello */

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Strings from '../../../translations/Translations';
import PSO from '../../../services/PSO';
import { useAuth } from '../../../context/auth/AuthContext';
import { toast } from 'react-toastify';
import './modalcreditstransactions.scss';

const convertDate = (date) => {
  const dateString = `${date}`;
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  const hour = dateString.substring(8, 10);
  const minute = dateString.substring(10, 12);
  const second = dateString.substring(12, 14);
  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
};

const filterItemDescription = (description) => {
  if (description === 'pso.remix.createRemixWithAIPlusVideo') {
    return Strings('create_remix_with_AI_plus_video');
  } else if (description === 'pso.remix.sendAIPhotoToRemix') {
    return Strings('send_AI_photo_to_remix');
  } else if (description === 'pso.remix.sendAIPlusVideoToRemix') {
    return Strings('send_AI_video_to_remix');
  }
  return description.charAt(0).toUpperCase() + description.slice(1); // First letter UPPER CASE
};

export default function ModalCreditsTransactions({ isOpen, setIsOpen, confirm }) {
  const toggle = useCallback(() => setIsOpen(value => !value), [setIsOpen]);

  const { authenticated } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [creditsTransactions, setCreditsTransactions] = useState();

  const getUserTransactions = useCallback(async () => {
    setCreditsTransactions();

    setIsLoading(true);

    try {
      const response = await PSO.getUserTransactions({ un: authenticated.un, al: authenticated.al });
      if (response && response.result === 'success' && response.its) {
        setCreditsTransactions(response.its);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_get_user_credits_transactions');
        toast.error(message);
      }
    } catch (err) {
      console.error(err);
      toast.error(`${Strings('error_on_get_user_credits_transactions')} [REQ]`);
    }

    setIsLoading(false);
  }, [authenticated]);

  useEffect(() => {
    if (isOpen) {
      getUserTransactions();
    }
  }, [isOpen, getUserTransactions]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size='lg' className='modalcreditstransactions'>
      <ModalHeader toggle={toggle}>
        {Strings('credits_transactions')}
      </ModalHeader>
      <ModalBody>
        {isLoading && <span>{Strings('loading')}</span>}

        {creditsTransactions && creditsTransactions.length === 0 && (
          <p className='p text-muted'>{Strings('no_transactions_here_yet')}</p>
        )}

        {creditsTransactions && creditsTransactions.length && creditsTransactions.map((item, index) => (
          <div className='row py-2' key={`${item.create_date}_${index}`}>
            <div className='col-sm-12 col-md-3'>
              <small className='fw-bold'>{Strings('date')}</small>
              <p className='font-size-14px m-0'>{convertDate(item.create_date)}</p>
            </div>
            <div className='col-sm-12 col-md-3'>
              <small className='fw-bold'>{Strings('amount')}</small>
              <p className='font-size-14px m-0'>{item.amount}</p>
            </div>
            <div className='col-sm-12 col-md-6'>
              <small className='fw-bold'>{Strings('description')}</small>
              <p className='font-size-14px m-0'>{filterItemDescription(item.description)}</p>
            </div>
          </div>
        ))}
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start'>
        <Button color='secondary' onClick={toggle}>
          {Strings('close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}